
<ng-container *ngIf="{
  totalizers: totalizers$ | async,
  requestTotalizers: requestTotalizers$ | async
} as resolved">
  <ng-container *ngIf="resolved.totalizers as totalizers; else noDataSkeleton">
    <lib-block-title
      id="totalizer-title"
      [title]="labels.title">
    </lib-block-title>
    <div id="energy-item">
      <ng-container *ngIf="totalizers.energies.length; else waitTotalizers">
        <app-key-value-block
          *ngFor="let item of totalizers.energies; let index = index"
          [key]="labels[item.name]"
          [value]="(item.value | number: '1.0-2': locate ) + ' kWh'"
          [bgColor]="item?.bgColor">
        </app-key-value-block>
      </ng-container>
    </div>

    <div
      id="co2-saved"
      class="tw-flex tw-flex-wrap tw-gap-3 tw-justify-around tw-items-center tw-h-full">
      <ng-container *ngTemplateOutlet="cardTemplate; context: {
          img: 'blocks-assets/images/forest.svg',
          label: labels.treeNeededToOffsetCO2,
          value: totalizers.treePlanted,
          unit: ''
        }">
      </ng-container>
      <ng-container *ngTemplateOutlet="cardTemplate; context: {
          img: 'blocks-assets/images/carbon-footprint.svg',
          label: labels.kilometersOfCarTravelSaved,
          value: totalizers.kmSaved,
          unit: 'km'
        }">
      </ng-container>
      <ng-container *ngTemplateOutlet="cardTemplate; context: {
          img: 'blocks-assets/images/co2.svg',
          label: labels.KilogramsOfCO2Saved,
          value: totalizers.co2Saved,
          unit: 'kg'
        }">
      </ng-container>
    </div>
  </ng-container>
</ng-container>

<ng-template #noDataSkeleton>
  <ion-skeleton-text
    class="w-30 h-10"
    id="totalizer-title"
    [animated]="true">
  </ion-skeleton-text>
  <div id="energy-item">
    <ng-container *ngTemplateOutlet="waitTotalizers"></ng-container>
  </div>
  <div
    id="co2-saved"
    class="tw-flex tw-gap-3 tw-justify-around tw-items-center tw-h-full">
    <ion-skeleton-text
      *ngFor="let _ of [].constructor(3)"
      class="h-20"
      [animated]="true">
    </ion-skeleton-text>
  </div>
</ng-template>

<ng-template #waitTotalizers>
  <ion-skeleton-text
    *ngFor="let _ of [].constructor(6)"
    class="h-19"
    [animated]="true">
  </ion-skeleton-text>
</ng-template>

<ng-template
  #cardTemplate
  let-img="img"
  let-label="label"
  let-value="value"
  let-unit="unit">
  <div class="radius-4 fx-g-1 fx-b-0 fx-gap-3 fx-row fx-center border-1 border-green-400 px-3">
    <img
      class="s-20 min-s-20"
      [src]="img">

    <div class="fx-g-1 fx-center tw-text-sm tw-font-medium text-grey-400">
      {{ label }}
    </div>
    <div class="text-nowrap fx-g-1 fx-center text-no-case tw-text-base tw-font-normal text-grey-400">
      {{ value | number: '1.0-2' : locate }} {{ unit }}
    </div>
  </div>
</ng-template>

